<template>
  <div>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>

    <!--   Main Content Start Here   -->
    <main>
      <section class="account_wraper">
        <div class="container_large">
          <div class="login_holder">
            <h4>Welcome Back!</h4>
            <h1>Login to your Account</h1>
            <span style="color: green">{{ messageNotify }}</span>
            <form method="" action="" @submit.prevent="submit()">
              <div class="form_holder">
                <div class="form_group">
                  <input
                    type="email"
                    name=""
                    placeholder="Email"
                    v-model="loginObj.email"
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                  <span
                    v-if="errors && errors.message"
                    style="color: #b22222"
                    >{{ errors.message }}</span
                  >
                </div>
                <div class="form_group mb-4">
                  <input
                    type="password"
                    name=""
                    placeholder="Password"
                    v-model="loginObj.password"
                  />
                </div>
                <div class="form_group mb-4">
                  <div class="forgot_password">
                    <router-link :to="{name:'forget-password'}">Forgot Your Password?</router-link>
                  </div>
                </div>
                <div class="button_holder">
                  <button type="submit" class="button primary_button">
                    Login <i class="fi fi-rr-angle-small-right"></i>
                  </button>
                  <!-- <span><router-link :to="{name:'signup'}">Sign Up</router-link></span> -->
                </div>
                <div class="agree_text">
                  By clicking on "Log In" you agree to the
                   <router-link :to="{name:'terms-and-conditions'}">Terms of Use</router-link> and
                    <router-link :to="{name:'privacy-policy'}">Privacy Policy</router-link> of dirtydrawz.com
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="men_holding_cloths">
          <img
            src="/src/assets/images/girl-with-laundry.png"
            class="img-fluid"
            alt=""
          />
        </div>
      </section>
    </main>
    <!--   Main Content End Here   -->
  </div>
</template>
<script>
import validationErrors from "../../mixins/validationErrors";
import { is422 } from "../../utils/response";
import { logIn, getCurrentUser, setCurrentUser, loginAdmin } from "../../utils/auth";
import usersApis from "../../Apis/users";
export default {
  mixins: [validationErrors],
  data() {
    return {
      loader: true,
      errors: null,
      status: null,
      loginObj: {
        email: "",
        password: "",
      },
      messageNotify: this.$route.params.messageNotify
    };
  },
  methods: {
    async submit() {
      this.loader = true;
      // await usersApis.logout();
      await usersApis.getCSRF();
      await usersApis
        .login(this.loginObj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            logIn();
            this.setUser();
          }
        })
        .catch((error) => {
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
        })
        .then(() => {
          this.loader = false;
        });
    },
    async setUser() {
      if (!getCurrentUser()) {
        await usersApis
          .getCurrentUser()
          .then(async (response) => {
            console.log(response);
            const user = response.data;
            setCurrentUser(user);
            this.$store.dispatch("islogedIn", user);
            this.loader = false;

          if(user.is_admin!=0){ 
              loginAdmin();
              this.$router.push({ name: "admin-dashboard" });
            } else{
             this.$router.push({ name: "order" });
            }

            
          })
          .catch((error) => {
            this.errors = { message: error.response.data.message };
            console.log(error);
            this.loader = false;
          })
          .then(() => {
            this.loader = false;
          });
      }
    },
  },
  async created() {
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Auth/login.vue